import Button from '@cobliteam/ui/components/Button';
import Icon from '@cobliteam/ui/icons';
import { useHistory } from 'react-router-dom';
import ShineBorder from '../../border/ShineBorder';

const AIButton = () => {
  const history = useHistory();

  return (
    <div className='relative rounded-md'>
      <ShineBorder borderWidth={2} />
      <Button variant='outlined' size='sm' onClick={() => history.push('/ai')} startIcon={<Icon name='sparkles' />} className='h-8'>
        Assistente
      </Button>
    </div>
  );
};

export default AIButton;
